import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/*
* Dimension
*
*/
export default class AutoObjDimension {
    public item: string;

    public flr: number;

    public p1: marietta.core.Point; // 寸法線 始点

    public p2: marietta.core.Point; // 寸法線 終点

    public p1w: marietta.core.Point; // 始点側 寸法足始点

    public p2w: marietta.core.Point; // 終点側 寸法足始点

    public dimStr: string; //  寸法文字

    public textP: marietta.core.Point; //  寸法文字表示位置 文字列中心の下

    public textAng: number; //  寸法文字表示角度  時計回り、度

    constructor(flr: any, p1: marietta.core.Point, p2: marietta.core.Point, p1w: marietta.core.Point, p2w: marietta.core.Point, dim: string) {
      this.item = 'dim';
      this.flr = flr;
      this.p1 = p1;
      this.p2 = p2;
      this.p1w = p1w;
      this.p2w = p2w;
      this.dimStr = dim;
      this.culcAngle();
    }

    public culcAngle() {
      if ((this.p1 != null) && (this.p2 != null)) {
        this.textP = AutoObjDimension.textPos(this.p1, this.p2);
        this.textAng = AutoObjDimension.textAngle(this.p1, this.p2);
      }
    }

    public readJSON(item: any, flr: number, sc: marietta3d.AutoGen.Scale, buildingType = null) {
      this.flr = flr;
      this.dimStr = item.text.toString();
      const points = item.point;

      this.p1 = new marietta.core.Point(points[2], points[3]);
      this.p2 = new marietta.core.Point(points[4], points[5]);
      this.p1w = new marietta.core.Point(points[0], points[1]);
      this.p2w = new marietta.core.Point(points[6], points[7]);
    //   this.p1 = new marietta.core.Point(item.dim_line.start.x, item.dim_line.start.y);
    //   this.p2 = new marietta.core.Point(item.dim_line.end.x, item.dim_line.end.y);
    //   this.p1w = new marietta.core.Point(item.pre.start.x, item.pre.start.y);
    //   this.p2w = new marietta.core.Point(item.post.end.x, item.post.end.y);
      if (buildingType !== null && buildingType === 1) {
        this.p1 = new marietta.core.Point(marietta.webcad.util.WebCADUtil.convertMMToPix(this.p1.x), marietta.webcad.util.WebCADUtil.convertMMToPix(this.p1.y));
        this.p2 = new marietta.core.Point(marietta.webcad.util.WebCADUtil.convertMMToPix(this.p2.x), marietta.webcad.util.WebCADUtil.convertMMToPix(this.p2.y));
        this.p1w = new marietta.core.Point(marietta.webcad.util.WebCADUtil.convertMMToPix(this.p1w.x), marietta.webcad.util.WebCADUtil.convertMMToPix(this.p1w.y));
        this.p2w = new marietta.core.Point(marietta.webcad.util.WebCADUtil.convertMMToPix(this.p2w.x), marietta.webcad.util.WebCADUtil.convertMMToPix(this.p2w.y));
      }
    }

    public readXML(item: Element, flr: number, sc: marietta3d.AutoGen.Scale) {
      const rattr = item.attributes;
      // const index = Number(rattr.getNamedItem('index').nodeValue);
      this.flr = flr;
      const p1w = new marietta.core.Point(0, 0, 0);
      const p2w = new marietta.core.Point(0, 0, 0);
      const p3 = new marietta.core.Point(0, 0, 0);
      p1w.x = Number(rattr.getNamedItem('x1').nodeValue);
      p1w.y = Number(rattr.getNamedItem('y1').nodeValue);
      p2w.x = Number(rattr.getNamedItem('x2').nodeValue);
      p2w.y = Number(rattr.getNamedItem('y2').nodeValue);
      p3.x = Number(rattr.getNamedItem('x3').nodeValue);
      p3.y = Number(rattr.getNamedItem('y3').nodeValue);
      const ln = new marietta3d.AutoGen.utils.RoomEdge();
      ln.CopyPointFrom(p1w, p2w);
      const d = ln.DistancePtoLine(p3);
      ln.GetOffsetEdge(d);
      const dim = Math.floor(sc.ConvertCadToWorld(ln.s.distanceTo(ln.e)));
      this.dimStr = dim.toString();
      this.p1 = ln.s;
      this.p2 = ln.e;
      this.p1w = p1w;
      this.p2w = p2w;
    }

    public static textAngle(k1: marietta.core.Point, k2: marietta.core.Point): number {
      let p1: marietta.core.Point;
      let p2: marietta.core.Point;
      if (k1.x === k2.x) {
        /* 縦 左へ */
        if (k1.y < k2.y) {
          p1 = k1;
          p2 = k2;
        } else {
          p1 = k2;
          p2 = k1;
        }
      } else if (k1.x < k2.x) {
        p1 = k1;
        p2 = k2;
      } else {
        p1 = k2;
        p2 = k1;
      }
      const d: number = new marietta.core.Point(p1.x, p1.y, p1.flag).angle(new marietta.core.Point(p2.x, p2.y, p2.flag));
      return -d;
    }

    public static textPos(k1: marietta.core.Point, k2: marietta.core.Point): marietta.core.Point {
      const ln = new marietta3d.AutoGen.utils.RoomEdge();
      ln.CopyPointFrom(k1, k2);
      let d: number;
      if (k1.x === k2.x) {
        /* 縦 左へ */
        if (k1.y < k2.y) {
          /* ↑ */
          d = 5;
        } else {
          /* ↓ */
          d = -5;
        }
      } else if (k1.x < k2.x) {
        /* → */
        d = 5;
      } else {
        /* ← */
        d = -5;
      }
      ln.GetOffsetEdge(d);
      const mid = ln.GetMidPoint();
      return mid;
    }

    /*
    * draw
    *
    */
    public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D) {
      const clBlack = '#000';
      // const clRed = '#fff';
      const cl = clBlack;
      const k1 = new marietta.core.Point(this.p1.x, this.p1.y, 0);
      const k2 = new marietta.core.Point(this.p2.x, this.p2.y, 0);
      const ln = new marietta3d.AutoGen.utils.RoomEdge();
      ln.CopyPointFrom(k1, k2);
      const mid = AutoObjDimension.textPos(ln.s, ln.e);
      const ang = AutoObjDimension.textAngle(ln.s, ln.e);
      const ip1 = sc.ConvertToCanvas(this.p1w);
      const ip2 = sc.ConvertToCanvas(this.p2w);
      const ik1 = sc.ConvertToCanvas(ln.s);
      const ik2 = sc.ConvertToCanvas(ln.e);
      const imid = sc.ConvertToCanvas(mid);
      const base = new marietta.core.Point(0, 0, 0);
      const w = new marietta.core.Point(imid.x, imid.y, 0);
      w.rotationRad(base, -ang);
      imid.x = w.x;
      imid.y = w.y;
      ctx.beginPath();
      ctx.strokeStyle = cl;
      ctx.fillStyle = cl;
      ctx.lineWidth = 1;
      ctx.moveTo(ip1.x, ip1.y);
      ctx.lineTo(ik1.x, ik1.y);
      ctx.lineTo(ik2.x, ik2.y);
      ctx.lineTo(ip2.x, ip2.y);
      ctx.stroke();
      ctx.rotate(ang);
      ctx.textAlign = 'center';
      ctx.fillText(this.dimStr, imid.x, imid.y);
      ctx.rotate(-ang);
    }

    /*
    * Hit test
    *
    */
    public IsHit(mp: marietta.core.Point): boolean {
      const k1 = new marietta.core.Point(this.p1.x, this.p1.y, 0);
      const k2 = new marietta.core.Point(this.p2.x, this.p2.y, 0);
      const ln = new marietta3d.AutoGen.utils.RoomEdge();
      ln.CopyPointFrom(k1, k2);
      if (ln.DistancePtoEdge(mp) < 5) {
        return true;
      }
      return false;
    }

    /*
    * Move
    *
    */
    public Move(x: number, y: number) {
      this.p1.x += x;
      this.p1.y += y;
      this.p2.x += x;
      this.p2.y += y;
      this.p1w.x += x;
      this.p1w.y += y;
      this.p2w.x += x;
      this.p2w.y += y;
    }
}
